const btnFormEquip = {
  text: 'novo serviço'
};

export default btnFormEquip;
